import type {
  AuthConfigDto,
  AuthenticatedUserDto,
  LoginInput,
  LogoutResultDto,
} from '@tacobots-forms/shared';
import { apiRequest } from '@/shared/api/client';

export const authKeys = {
  config: ['auth', 'config'] as const,
  me: ['auth', 'me'] as const,
};

export const fetchAuthConfig = () => apiRequest<AuthConfigDto>('/auth/config');

/**
 * Exchanges the portal's shared cookie for a session of our own.
 *
 * Throws when there is no portal session, which is the ordinary case for
 * somebody who arrived at the domain directly.
 */
export const exchangePortalSession = () =>
  apiRequest<AuthenticatedUserDto>('/auth/portal/exchange', { method: 'POST' });

export const fetchCurrentUser = () => apiRequest<AuthenticatedUserDto>('/auth/me');

export const login = (body: LoginInput) =>
  apiRequest<AuthenticatedUserDto>('/auth/login', { method: 'POST', body });

export const logout = () => apiRequest<LogoutResultDto>('/auth/logout', { method: 'POST' });

/** Full-page navigation: the OIDC flow has to leave the SPA. */
export function startEntraLogin(returnTo: string): void {
  const target = `/api/auth/entra/start?returnTo=${encodeURIComponent(returnTo)}`;
  window.location.assign(target);
}

/**
 * Single sign-on with tacobots.net. The endpoint reads the shared portal
 * cookie; if there is none it bounces to the portal and comes back here, so
 * from the browser's point of view this is one navigation either way.
 */
export function startPortalLogin(returnTo: string): void {
  const target = `/api/auth/portal/start?returnTo=${encodeURIComponent(returnTo)}`;
  window.location.assign(target);
}
